import { ResponsiveCard } from '../../molecules/card/Card';

export function OsasPresentationCard() {
    return (
        <ResponsiveCard
            body="Bekijk hier nog eens de presentatie met meer informatie over slaapapneu"
            cardTitle="Presentatie slaapapneu"
            icon="download"
            lg={12}
            linksText={['Presentatie over slaapapneu']}
            linksTo={['/assets/documents/About_Ksyos_sleep.pdf']}
            openInNewTab
            position="left"
        />
    );
}
